import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../store/app.states';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {RegistrationService} from '../../../services/registration.service';
import {PatientRegistration} from '../../../model/user/PatientRegistration';
import {BodyStat} from '../../../model/user/BodyStat';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {DateAdapter, MatOptionSelectionChange} from '@angular/material/core';
import {Router} from '@angular/router';
import {Patient} from '../../../model/user/Patient';
import {GetPatients} from '../../../store/actions/doctor.actions';

@Component({
  selector: 'app-patient-registration',
  templateUrl: './patient-registration.component.html',
  styleUrls: ['./patient-registration.component.css'],
})

export class PatientRegistrationComponent implements OnInit {

  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  patients: Patient[];
  title = 'Registrazione paziente';
  registrationForm: FormGroup;
  notFocused = false;
  birthDate: string;
  patientRegistrationBody: PatientRegistration;
  submitted: boolean;
  show = false;
  destination = 'patients-control-panel';
  pathologies = ['Malattia di Crohn', 'Colite ulcerosa', 'Altro'];
  otherPathology = false;
  choices = ['Random', 'Telemedicina', 'Cure tradizionali'];

  constructor(private store: Store<AppState>,
              private registrationService: RegistrationService,
              private dateAdapter: DateAdapter<Date>,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
    this.dateAdapter.setLocale('it');
  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
    });

    this.registrationForm = new FormGroup({
      email: new FormControl('', [Validators.required, this.myValidatorEmail]),
      name: new FormControl('', [Validators.required]),
      surname: new FormControl('', [Validators.required]),
      ssn: new FormControl('', [Validators.required,this.myValidatorSSN]),
      // birthPlace: new FormControl('', [Validators.required]),
      // province: new FormControl('', [Validators.required]),
      // cap: new FormControl('', [Validators.required]),
      // phoneNumber: new FormControl('', [Validators.required]),
      // weight: new FormControl('', [Validators.required, Validators.min(0)]),
      // height: new FormControl('', [Validators.required, Validators.min(0)]),
      pathology: new FormControl('', [Validators.required]),
      // category: new FormControl('', [Validators.required]),
    });

  }

  myValidatorEmail(control: FormControl) {
    if(control.value.includes("@") && control.value.includes(".")) 
      return null;
      else return {required: true}
   }

   myValidatorSSN(control: FormControl) {
    //deve rispettare il seguente formato
   var pattern = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
   if (control.value.search(pattern) == -1)
   {
     // In caso di errore 
     return {required: true}
   }else{
      // ...in caso contrario ok
      return null
   }
  }

  onSubmit(registration) {
    this.submitted = true;
    this.show = true;
    var newMail = registration.email.replace(/\s/g, "");
    var newSSN = registration.ssn.replace(/\s/g, "");

    // tslint:disable-next-line:max-line-length
    // weight: string, height: string, pathology: string, age: string, dateOfDiagnosis: string, ageOfDiagnosis: string, familiarity: string, pathologyDuration: string
    // tslint:disable-next-line:max-line-length
    // tslint:disable-next-line:max-line-length
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    this.patientRegistrationBody =
      // tslint:disable-next-line:max-line-length
      new PatientRegistration(
        newMail,
        registration.name,
        registration.surname,
        newSSN,
        this.birthDate,
        // registration.birthPlace + ' (' + registration.province + ') - ' + registration.cap,
        // registration.phoneNumber,
        doctorID,
        registration.pathology);

    console.log('CATEGORY:', registration.category);
    console.log(this.patientRegistrationBody);

    // ONLY RANDOM

    this.registrationService.registerPatient(this.patientRegistrationBody, 'RANDOM').subscribe(d => {
        if (d.status === 200) {
          // tslint:disable-next-line:only-arrow-functions
          this.router.navigateByUrl('/success').then(() => setTimeout(function() {
            location.replace('/patients-control-panel');
          }, 1500));
        }
      },
      error => {
        console.log(error);
        // tslint:disable-next-line:only-arrow-functions
        this.router.navigateByUrl('/error').then(() => setTimeout(function() {
          location.replace('/patients-control-panel');
        }, 2000));
      });
  }

  setDate($event: MatDatepickerInputEvent<any>) {
    this.birthDate =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10);

    console.log(this.birthDate);
  }

  selectResult($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      /*if (value.localeCompare('Altro') !== 0) { // per specificare altra patologia -> non più richiesto
        this.registrationForm.get('pathology').setValue(value);
        this.otherPathology = false;
      } else {
        this.registrationForm.get('pathology').reset();
        this.otherPathology = true;
      }*/
      this.registrationForm.get('pathology').setValue(value);
      this.otherPathology = false;
      console.log(this.registrationForm.get('pathology').value);
    }
  }

  selectChoice($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value.localeCompare('Random') === 0) {
        this.registrationForm.get('category').setValue('RANDOM');
      } else if (value.localeCompare('Telemedicina') === 0) {
        this.registrationForm.get('category').setValue('TELEMEDICINA');
      } else {
        this.registrationForm.get('category').setValue('STANDARD');
      }
      console.log(this.registrationForm.get('category').value);
    }
  }
}
